import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { AppService } from '@nk/access-block';
import { SCREENING_CONFIG_API_SERVICE_TOKEN, ScreeningConfigApiService } from '@nk/api-lib';
import { ScreeningConfigEntity } from '@nk/data-entities-lib';
import { Observable, tap } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export interface ScreeningRoutingData {
  entityData: ScreeningConfigEntity | null;
  breadcrumbPath: string | null;
  ignoreTabs: string[];
}

/**
 * Functional resolver for screening routes.
 * Entity data will be used in the component. Its type varies: for company it is companyEntity, for watchlist it will be a watchlist entity.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const screeningRoutingResolver: ResolveFn<ScreeningRoutingData | null> = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  route: ActivatedRouteSnapshot,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  state: RouterStateSnapshot,
): Observable<ScreeningRoutingData | null> => {
  const router = inject(Router);
  const appService = inject(AppService);
  const screeningConfigService = inject<ScreeningConfigApiService>(SCREENING_CONFIG_API_SERVICE_TOKEN);

  return appService.identityDataCache.get().pipe(
    switchMap((identity) => {
      return screeningConfigService.screeningConfigsListCache.get(identity.app_customer.uuid).pipe(
        tap((screeningConfigList) => {
          if (!screeningConfigList?.length) {
            router.navigate(['/screening/create-screening-config']);
          }
        }),
        map((screeningConfigList) => {
          if (screeningConfigList?.length) {
            return {
              entityData: screeningConfigList[0],
              breadcrumbPath: 'Screening',
              ignoreTabs: [],
            };
          } else {
            return null;
          }
        }),
      );
    }),
  );
};
